import BETA_RELEASE from "@/constants/beta-release";

export default {
    computed: {
        isNotifcationFeatureEnabled() {
            const featuresEnabled = this.$store.getters["featuresEnabled"];

            if (
                featuresEnabled &&
                featuresEnabled[BETA_RELEASE.KEY.NOTIFICATION]
            ) {
                return featuresEnabled[BETA_RELEASE.KEY.NOTIFICATION];
            } else {
                return false;
            }
        },
        isCubexFeatureEnabled() {
            const featuresEnabled = this.$store.getters["featuresEnabled"];
            return featuresEnabled && featuresEnabled[BETA_RELEASE.KEY.CUBEX];
        }
    }
};
